import React from 'react';
import { m as motion } from 'framer-motion';
import { Container } from './ui/Container';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
const columns = [{
  title: 'Sin preguntas',
  copy: 'No pedimos explicaciones'
}, {
  title: 'Sin formularios',
  copy: 'Solo un correo electrónico'
}, {
  title: 'Devolución en 24h',
  copy: 'Rápido y sin drama'
}];
export function GuaranteeSection() {
  return <section className="bg-mp-dark py-20 md:py-24" data-id="element-147" data-mp="jrr7p6c7o9uy">
      <Container data-id="element-148" data-mp="nu47zf86vfkc">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        ease: easeOut
      }} className="mx-auto max-w-[820px] rounded-2xl border border-mp-lime/30 bg-mp-card p-8 text-center md:p-12" data-id="element-149" data-mp="ntm90au56n8q">
          <span className="text-5xl" role="img" aria-label="Escudo de garantía" data-id="element-150" data-mp="12kv3oycwiysq">
            🛡️
          </span>

          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-151" data-mp="17g0jrgjmhj8w">
            Garantía total de 14 días
          </h2>
          <p className="mt-2 font-heading text-sm uppercase tracking-wide text-mp-lime md:text-base" data-id="element-152" data-mp="20rspgodinj4j">
            Si no es para ti, te devolvemos el 100%.
          </p>

          <div className="mx-auto mt-6 max-w-[600px] space-y-1 text-sm leading-relaxed text-mp-gray md:text-base" data-id="element-153" data-mp="1rsfj44kovao1">
            <p data-id="element-154" data-mp="2oiogvke28cb9">Prueba el material sin ningún riesgo.</p>
            <p data-id="element-155" data-mp="2ok9an7sjvr82">Revisa los 5 tomos. Usa las fichas en pista.</p>
            <p data-id="element-156" data-mp="2jkmvutx2q2x5">
              Si en 14 días no sientes que Maestro en Pista ha mejorado tu forma de planificar y dar clases,
              escríbenos y te devolvemos el importe completo en menos de 24 horas.
            </p>
            <p className="pt-2 font-medium text-mp-white" data-id="element-157" data-mp="2aoxgp2m7y4s7">Sin formularios. Sin preguntas. Sin drama.</p>
            <p className="pt-2 text-mp-gray/80" data-id="element-158" data-mp="37b0s6wmoynxj">Nuestra tasa de devolución es menor al 1%.</p>
          </div>

          <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-3" data-id="element-159" data-mp="32gcz0kgqt5cm">
            {columns.map(col => <div key={col.title} className="rounded-xl border border-mp-border bg-mp-dark p-5" data-id="element-160" data-mp="15jqr5imt2cud">
                <p className="font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-161" data-mp="quuflbljihp0">{col.title}</p>
                <p className="mt-1 text-xs text-mp-gray md:text-sm" data-id="element-162" data-mp="vtnt340tu8p6">{col.copy}</p>
              </div>)}
          </div>
        </motion.div>
      </Container>
    </section>;
}